import { useState, useEffect } from "react";
import api from "../../api/axios";
import Swal from "sweetalert2";
import { useNavigate } from "react-router-dom";
import { Autocomplete, TextField } from "@mui/material";
import { LEAD_STATUSES } from "../Common/LeadStatus";

import "../../assets/css/Leads/LeadsCreate.css";
import {
  FaBullseye,
  FaBuilding,
  FaUser,
  FaTasks,
  FaUserTie,
  FaFire,
  FaGlobe,
  FaRupeeSign,
  FaFileAlt,
} from "react-icons/fa";


export default function LeadsCreate({ onClose, onSuccess, initialData } = {}) {
  const navigate = useNavigate();

  const [form, setForm] = useState({
    title: initialData?.title || "",
    organization_id: initialData?.organization_id || "",
    contact_id: initialData?.contact_id || "",
    description: initialData?.description || "",
    lead_type: initialData?.lead_type || "One-Time",
    status: initialData?.status || "",
    lost_reason: initialData?.lost_reason || "",
    source: initialData?.source || "",
    value: initialData?.value || "",
    assigned_to: initialData?.assigned_to || "",
  });

  // rest of your code...
  const [errors, setErrors] = useState({});
  const [organizations, setOrganizations] = useState([]);
  const [contacts, setContacts] = useState([]);
  const [users, setUsers] = useState([]);

  const [loading, setLoading] = useState(false);
  const statusOptions = LEAD_STATUSES.map((val) => ({ value: val, label: val }))

  const leadTypeOptions = [
    { value: "Fresh", label: "Fresh" },
    { value: "Warm", label: "Warm" },
    { value: "Hot", label: "Hot" },
    { value: "Cold", label: "Cold" },
  ];


  const sourceOptions = [
    { value: "Website", label: "Website" },
    { value: "Referral", label: "Referral" },
    { value: "Phone", label: "Phone" },
    { value: "Email", label: "Email" },
    { value: "Social Media", label: "Social Media" },
    { value: "Manual", label: "Manual" },
  ];
  // close handler
  const handleClose = () => {
    if (onClose) {
      onClose();
    } else {
      navigate("/leads"); // or whatever route contains the list
    }
  };
  useEffect(() => {
    const fetchData = async () => {
      try {
        console.log("trying to fetch data")
        const [orgRes, contactRes, userRes] = await Promise.all([
          api.get("/organization/"),
          api.get("/contact/list"),
          api.get("/users"),
        ]);

        setOrganizations(orgRes.data);
        console.log(contactRes.data);
        setContacts(contactRes.data);
        setUsers(userRes.data);
      } catch (err) {
        console.error(err);
      }
    };

    fetchData();
  }, []);

  //handle change


  const handleChange = (e) => {
    const { name, value } = e.target;

    if (name === "value") {
      const numericValue = value.replace(/,/g, "").replace(/\D/g, "");

      setForm((prev) => ({
        ...prev,
        value: numericValue,
      }));

      setErrors((prev) => ({
        ...prev,
        value: "",
      }));

      return;
    }

    if (name === "organization_id") {
      setForm((prev) => ({
        ...prev,
        organization_id: value,
        contact_id: "",
      }));
    } else {
      setForm((prev) => ({
        ...prev,
        [name]: value,
      }));
    }

    setErrors((prev) => ({
      ...prev,
      [name]: "",
    }));
  };

  //validation

  const isBlank = (val) => !val || String(val).trim() === "";

  const validate = () => {
    const newErrors = {};

    if (isBlank(form.title)) {
      newErrors.title = "Lead title is required";
    }

    if (isBlank(form.organization_id)) {
      newErrors.organization_id = "Organization is required";
    }

    if (isBlank(form.contact_id)) {
      newErrors.contact_id = "Contact is required";
    }

    if (isBlank(form.status)) {
      newErrors.status = "Status is required";
    }

    if (isBlank(form.assigned_to)) {
      newErrors.assigned_to = "Please assign a user";
    }

    if (isBlank(form.lead_type)) {
      newErrors.lead_type = "Lead type is required";
    }

    if (isBlank(form.source)) {
      newErrors.source = "Source is required";
    }

    // Lead Value validation
    if (isBlank(form.value)) {
      newErrors.value = "Lead value is required";
    } else if (Number(form.value) <= 0) {
      newErrors.value = "Lead value must be greater than 0";
    }

    setErrors(newErrors);

    return Object.keys(newErrors).length === 0;
  };

  //submission

  const submit = async (e) => {
    e.preventDefault();
    console.log("submitted");
    if (!validate()) return;
    console.log("validated");
    try {
      setLoading(true);

      await api.post("/lead/create", {
        ...form,
        organization_id: form.organization_id
          ? Number(form.organization_id)
          : null,
        contact_id: form.contact_id
          ? Number(form.contact_id)
          : null,
        assigned_to: form.assigned_to
          ? Number(form.assigned_to)
          : null,
      });

      await Swal.fire({
        icon: "success",
        title: "Lead Created",
        timer: 1200,
        showConfirmButton: false,
      });

      if (onSuccess) {
        onSuccess();
      } else {
        navigate("/leads");
      }
    } catch (err) {
      const errors = err.response?.data;

      let message = "Failed to create lead";

      if (errors && typeof errors === "object") {
        message = Object.entries(errors)
          .map(([field, msgs]) => {
            const text = Array.isArray(msgs) ? msgs.join(", ") : msgs;
            return `${field}: ${text}`;
          })
          .join("\n");
      }

      Swal.fire({
        icon: "error",
        title: "Validation Error",
        html: message.replace(/\n/g, "<br/>"),
      });
    }

  };




  console.log("Form id", form.organization_id);
  // const filteredContacts = contacts.filter(
  //   (c) =>
  //     Number(c.organizations.id) === Number(form.organization_id)
  // );

  const filteredContacts = contacts.filter((c) =>
    Array.isArray(c?.organizations)
      ? c.organizations.some(
          (org) => Number(org.id) === Number(form.organization_id)
        )
      : Number(c?.organization_id) === Number(form.organization_id)
  );

  return (

    <div className="lead-create__overlay" onClick={handleClose}>
      <div
        className="lead-create__card"
        onClick={(e) => e.stopPropagation()}
      >
        {/* HEADER */}
        <div className="lead-create__header">
          <h3 className="lead-create__title">Create Lead</h3>

          <button
            className="lead-create__close-btn"
            onClick={handleClose}
          >
            ✕
          </button>
        </div>

        {/* BODY */}
        <form onSubmit={submit} className="lead-create__body">
          <div className="lead-create__grid">

            {/* TITLE */}
            <div className="lead-create__group">
              <label>Lead Title</label>

              <div className="lead-create__input-wrapper">
                <FaBullseye className="lead-create__icon" />

                <input
                  name="title"
                  value={form.title}
                  onChange={handleChange}
                  className={errors.title ? "input-error" : ""}
                />
              </div>

              {errors.title && (
                <small className="error-text">{errors.title}</small>
              )}
            </div>

            {/* ORGANIZATION */}
            <div className="lead-create__group">
              <label>Organization</label>

              <div className="lead-create__input-wrapper">
                <FaBuilding className="lead-create__icon" />

                <Autocomplete
                  className="lead-create__autocomplete"
                  options={organizations}
                  getOptionLabel={(option) => option.name || ""}
                  value={
                    organizations.find(
                      (org) => String(org.id) === String(form.organization_id)
                    ) || null
                  }



                  onChange={(event, newValue) => {
                    setForm((prev) => ({
                      ...prev,
                      organization_id: newValue ? String(newValue.id) : "",
                      contact_id: "", // clear previous selection
                    }));
                  }}


                  isOptionEqualToValue={(option, value) =>
                    String(option.id) === String(value.id)
                  }
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      placeholder="Select Organization"
                      error={!!errors.organization_id}
                    />
                  )}
                />
              </div>

              {errors.organization_id && (
                <small className="error-text">
                  {errors.organization_id}
                </small>
              )}
            </div>
            {/* CONTACT */}
            <div className="lead-create__group">
              <label>Contact</label>

              <div className="lead-create__input-wrapper">
                <FaUser className="lead-create__icon" />

                <Autocomplete
                  className="lead-create__autocomplete"
                  options={filteredContacts}
                  disabled={!form.organization_id}
                  getOptionLabel={(option) =>
                    `${option.first_name || ""} ${option.second_name || option.last_name || ""}`.trim()
                  }
                  value={
                    filteredContacts.find(
                      (contact) => String(contact.id) === String(form.contact_id)
                    ) || null
                  }


                  onChange={(event, newValue) => {
                    setForm((prev) => ({
                      ...prev,
                      contact_id: newValue ? String(newValue.id) : "",
                    }));
                  }}


                  isOptionEqualToValue={(option, value) =>
                    String(option.id) === String(value.id)
                  }
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      placeholder={
                        form.organization_id
                          ? "Select Contact"
                          : "Select Organization First"
                      }
                      error={!!errors.contact_id}
                    />
                  )}
                />
              </div>

              {errors.contact_id && (
                <small className="error-text">
                  {errors.contact_id}
                </small>
              )}
            </div>

            <div className="lead-create__group">
              <label>Status</label>

              <div className="lead-create__input-wrapper">
                <FaTasks className="lead-create__icon" />

                <Autocomplete
                  className="lead-create__autocomplete"
                  options={statusOptions}
                  getOptionLabel={(option) => option.label}
                  value={
                    statusOptions.find(
                      (option) => option.value === form.status
                    ) || null
                  }
                  onChange={(event, newValue) =>
                    setForm((prev) => ({
                      ...prev,
                      status: newValue?.value || "",
                    }))
                  }
                  disableClearable
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      placeholder="Select Status"
                      error={!!errors.status}
                    />
                  )}
                />
              </div>

              {errors.status && (
                <small className="error-text">{errors.status}</small>
              )}
            </div>

            <div className="lead-create__group">
              <label>Assigned User</label>

              <div className="lead-create__input-wrapper">
                <FaUserTie className="lead-create__icon" />

                <Autocomplete
                  className="lead-create__autocomplete"
                  options={users}
                  getOptionLabel={(option) => option.name || ""}
                  value={
                    users.find(
                      (user) => String(user.id) === String(form.assigned_to)
                    ) || null
                  }
                  onChange={(event, newValue) =>
                    setForm((prev) => ({
                      ...prev,
                      assigned_to: newValue ? String(newValue.id) : "",
                    }))
                  }
                  isOptionEqualToValue={(option, value) =>
                    String(option.id) === String(value.id)
                  }
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      placeholder="Assign User"
                      error={!!errors.assigned_to}
                    />
                  )}
                />
              </div>

              {errors.assigned_to && (
                <small className="error-text">{errors.assigned_to}</small>
              )}
            </div>


            <div className="lead-create__group">
              <label>Lead Type</label>

              <div className="lead-create__input-wrapper">
                <FaFire className="lead-create__icon" />

                <TextField
                  className="lead-create__autocomplete"
                  value="One-time"
                  name="lead_type"
                  InputProps={{
                    readOnly: true,
                  }}
                  fullWidth
                />
              </div>
            </div>

            <div className="lead-create__group">
              <label>Source</label>

              <div className="lead-create__input-wrapper">
                <FaGlobe className="lead-create__icon" />

                <Autocomplete
                  className="lead-create__autocomplete"
                  options={sourceOptions}
                  getOptionLabel={(option) => option.label}
                  value={
                    sourceOptions.find(
                      (option) => option.value === form.source
                    ) || null
                  }
                  onChange={(event, newValue) =>
                    setForm((prev) => ({
                      ...prev,
                      source: newValue?.value || "",
                    }))
                  }
                  disableClearable
                  renderInput={(params) => (
                    <TextField

                      {...params}
                      placeholder="Select Source"
                      error={!!errors.source}
                    />
                  )}
                />
              </div>

              {errors.source && (
                <small className="error-text">{errors.source}</small>
              )}
            </div>

            <div className="lead-create__group">
              <label>Lead Value</label>

              <div className="lead-create__input-wrapper">
                <FaRupeeSign className="lead-create__icon" />

                <input
                  type="text"
                  name="value"
                  value={
                    form.value
                      ? Number(form.value).toLocaleString("en-IN")
                      : ""
                  }
                  onChange={handleChange}
                  placeholder="Enter value"
                  className={errors.value ? "input-error" : ""}
                />
              </div>

              {errors.value && (
                <small className="error-text">
                  {errors.value}
                </small>
              )}
            </div>

            {/* DESCRIPTION */}
            <div className="lead-create__group lead-create__full">
              <label>Description</label>

              <div className="lead-create__input-wrapper">
                <FaFileAlt className="lead-create__icon lead-create__icon--top" />

                <textarea
                  name="description"
                  value={form.description}
                  onChange={handleChange}
                />
              </div>
            </div>
          </div>

          {/* FOOTER */}
          <div className="lead-create__actions">
            <button
              type="button"
              className="lead-create__btn lead-create__btn--secondary"
              onClick={handleClose}
            >
              Cancel
            </button>

            <button
              type="submit"
              disabled={loading}
              className="lead-create__btn lead-create__btn--primary"
            >
              {loading ? "Saving..." : "Save Lead"}
            </button>
          </div>
        </form>
      </div>
    </div>

  );
}
